module.exports = __webpack_public_path__ + "img/featured-img-section-bg.e259f83b.jpg";